// extracted by mini-css-extract-plugin
module.exports = {"toBeAnnouncedLocation":"ToBeAnnouncedLocation_toBeAnnouncedLocation__tHTNE","text":"ToBeAnnouncedLocation_text___uMST"};